<template>
  <div>
    <px-view-header title="Cadastro de Projeto"
                    title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>
    <div v-if="loadingProjeto">
      <px-circular-loading/>
    </div>
    <v-container>
      <v-row dense>
        <v-col cols="12" sm="6">
          <v-text-field
            dense
            outlined
            required
            hide-details
            maxlength="100"
            class="required rounded-tag-small"
            label="Descrição do projeto"
            :error="$v.projeto.descricao.$error"
            @blur="$v.projeto.descricao.$touch()"
            v-model="projeto.descricao"
          />
        </v-col>
        <v-col cols="12" sm="5">
          <v-text-field
            dense
            outlined
            hide-details
            maxlength="100"
            class="rounded-tag-small"
            label="Código do projeto"
            v-model="projeto.codigoInterno"
          />
        </v-col>
        <v-col cols="12" sm="1">
          <v-switch dense
                    hide-details
                    class="pa-0 mt-2 mr-2"
                    label="Ativo"
                    color="primary"
                    v-model="projeto.ativo"/>
        </v-col>
      </v-row>
      <div class="mt-5">
        <v-btn color="primary"
               class="normal-btn-text rounded-tag-small elevation-0"
               @click="onClickSave"
               :loading="loading">
          Salvar
        </v-btn>
        <v-btn text class="normal-btn-text" @click="onClickBack">Cancelar</v-btn>
      </div>
    </v-container>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import validationMixin from '@/mixins/validation-mixin';
import ProjetoService from './projeto-service';

export default {
  mixins: [validationMixin],
  data() {
    return {
      loading: false,
      loadingProjeto: false,
      projeto: {
        descricao: null,
        codigoInterno: null,
        ativo: true,
      },
      idProjeto: this.$route.params.id,
      breadcrumbs: [
        { text: 'Empresa' },
        { text: 'Projeto' },
      ],
    };
  },
  methods: {
    onClickBack() {
      this.$router.push({ name: 'main.projetos' });
    },
    getProjeto() {
      this.loadingProjeto = true;
      ProjetoService.get(this.idProjeto)
        .then((response) => {
          this.projeto = response.data;
        })
        .finally(() => {
          this.loadingProjeto = false;
        });
    },
    buildProjeto() {
      const projeto = { ...this.projeto };
      projeto.descricao = projeto.descricao.trim();
      if (projeto.codigoInterno) {
        projeto.codigoInterno = projeto.codigoInterno.trim();
      }
      return projeto;
    },
    salvar() {
      this.loading = true;
      ProjetoService.save(this.buildProjeto())
        .then(() => {
          this.$toast('Projeto criado com sucesso', { color: 'success' });
          this.onClickBack();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onClickSave() {
      if (this.validateForm()) {
        return;
      }
      this.salvar();
    },
  },
  created() {
    if (this.idProjeto) {
      this.getProjeto();
    }
  },
  validations: {
    projeto: {
      descricao: {
        required,
      },
    },
  },
};
</script>
